// src/App/Animations/HeroAnimation.js
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(SplitText);

import Animation from "./Animation.js";

export default class DefaultAnimation extends Animation {
  constructor(element) {
    super(element);
  }

  setInitialState() {
    this.projectsText = this.element.querySelectorAll(".projects__text");
    this.subText = this.element.querySelector(".projects__subtext");
    this.button = this.element.querySelector(".projects__button");
    this.splittedText = SplitText.create(this.projectsText, {
      linesClass: "line",
    });

    gsap.set(this.splittedText.words, { yPercent: 100 });
    gsap.set(this.subText, { yPercent: 100, opacity: 0 });
    gsap.set(this.button, { yPercent: 100, opacity: 0 });
  }

  createTimeline() {
    const tl = gsap.timeline({ paused: true });

    tl.to(this.splittedText.words, {
      // autoAlpha: 1,
      yPercent: 0,
      duration: 0.5,
      stagger: 0.05,
      ease: "power3.out",
    })
      .to(
        this.subText,
        {
          opacity: 1,
          yPercent: 0,
          duration: 0.75,
          ease: "power3.out",
        },
        "<+0.25"
      )
      .to(
        this.button,
        {
          opacity: 1,
          yPercent: 0,
          duration: 0.75,
          ease: "power3.out",
        },
        "<0"
      );

    return tl;
  }
}
